import * as tslib_1 from "tslib";
import styled from '@/shared/styled';
import { Icon, Input, message, Popover } from 'antd';
import React, { Component, useEffect, useState } from 'react';
import createModal from '@/shared/create-modal';
import Form from 'antd/lib/form';
import { addCustomMenu, deleteCustomMenu, getCustomMenu, sendTrace, } from '@/services/menu';
const ROOT = styled.div `
  color: rgba(255, 255, 255, 0.65);
  padding: 0 20px;
  cursor: pointer;
  :hover {
    color: rgba(255, 255, 255, 1);
  }
`;
const CONTENT = styled.div `
  width: 160px;
  .my-menu-item {
    display: relative;
    overflow: hidden;
    line-height: 40px;
    color: rgba(255, 255, 255, 0.65);
    cursor: pointer;
    :hover {
      color: rgba(255, 255, 255, 1);
    }
  }
`;
const CustomMenu = ({ className, style }) => {
    const [menus, setMenus] = useState([]);
    useEffect(() => {
        getCustomMenu().promise.then(res => {
            setMenus(res);
        });
    }, []);
    const content = () => {
        return (<CONTENT>
        {menus.map((item) => (<div key={item.id} className="my-menu-item" onClick={e => {
            sendTrace(2);
            if (item.menuUrl.startsWith('http')) {
                window.open(item.menuUrl);
            }
            else {
                window.open('http://' + item.menuUrl);
            }
            e.stopPropagation();
        }} onContextMenu={e => {
            e.stopPropagation();
            e.preventDefault();
            if (e.target &&
                (e.target.tagName === 'div' || e.target.tagName === 'DIV')) {
                e.target.children[0].style.visibility = 'inherit';
            }
            else if (e.target &&
                (e.target.tagName === 'span' || e.target.tagName === 'SPAN')) {
                e.target.style.visibility = 'inherit';
            }
        }} onMouseOut={e => {
            const target = e.relatedTarget;
            const source = e.target;
            e.stopPropagation();
            e.preventDefault();
            if (source.contains(target)) {
                return;
            }
            if (e.target &&
                (e.target.tagName === 'div' || e.target.tagName === 'DIV')) {
                e.target.children[0].style.visibility = 'hidden';
            }
        }}>
            {item.menuName}
            <Icon type="close" style={{
            position: 'absolute',
            right: '18px',
            visibility: 'hidden',
            marginTop: '14px',
        }} onClick={e => {
            e.stopPropagation();
            createModal({
                title: '删除自定义菜单',
                content: <div>确定删除自定义菜单:{item.menuName}</div>,
                onOk: () => {
                    deleteCustomMenu(item.id).promise.then(() => {
                        message.info('删除成功');
                        getCustomMenu().promise.then(res => {
                            setMenus(res);
                        });
                    });
                },
            });
        }}/>
          </div>))}
        <div className="my-menu-item" onClick={e => {
            e.preventDefault();
            createModal({
                title: '添加自定义菜单',
                width: '50%',
                content: <AddCustomMenuForm />,
                onOk: values => {
                    addCustomMenu(values).promise.then(() => {
                        message.info('添加成功');
                        getCustomMenu().promise.then(res => {
                            setMenus(res);
                        });
                    });
                },
            });
        }}>
          + 添加菜单
        </div>
      </CONTENT>);
    };
    return (<ROOT className={className} style={style}>
      <Popover content={content()} placement="bottom" trigger="hover" overlayClassName={'my-custom-menu'}>
        <p>自定义菜单</p>
      </Popover>
    </ROOT>);
};
export default CustomMenu;
class AddCustomMenuModal extends Component {
    onModalOk() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { form: { validateFields }, } = this.props;
            const values = yield new Promise((resolve, reject) => {
                validateFields((errs, values) => {
                    if (errs)
                        return reject(errs);
                    resolve(values);
                });
            });
            return values;
        });
    }
    render() {
        const { className, style, form } = this.props;
        const { getFieldDecorator } = form;
        return (<div className={className} style={style}>
        <Form>
          <Form.Item label="菜单链接">
            {getFieldDecorator('menuUrl', {
            rules: [{ required: true, message: '菜单链接必填' }],
        })(<Input />)}
          </Form.Item>
          <Form.Item label="菜单名称">
            {getFieldDecorator('menuName', {
            rules: [{ required: true, message: '菜单名称必填' }],
        })(<Input />)}
          </Form.Item>
        </Form>
      </div>);
    }
}
const AddCustomMenuForm = Form.create()(AddCustomMenuModal);
